<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%" v-if="!qusetionDetailDialog">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">统计分析管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>错题审核</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="审核状态">
                  <el-select
                    filterable
                    placeholder="请选择审核状态"
                    clearable
                    v-model="form.errAuditState"
                  >
                    <el-option
                      v-for="item in applyStateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="数据来源">
                  <el-select
                    filterable
                    placeholder="请选择数据来源"
                    clearable
                    v-model="form.reportSource"
                  >
                    <el-option
                      v-for="item in taskTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="案件号">
                  <el-input
                    v-model="form.caseNumber"
                    clearable
                    placeholder="请输入案件号搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="指标">
                  <el-input
                    v-model="form.eventIndexName"
                    clearable
                    placeholder="请输入指标"
                  ></el-input>
                </el-form-item>
                <el-form-item label="点位">
                  <el-input
                    v-model="form.pointName"
                    clearable
                    placeholder="请输入社区或网格名称搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="错题上报时间">
                  <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="640"
          >
            <template v-slot:reportSource="{ scope }">
              <span>{{ taskTypeObj[scope.row.reportSource] }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                v-if="scope.row.errAuditState == '待审核'"
                @click="apply(scope.row, 1)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >审核</el-button
              >
              <el-button
                v-else
                @click="apply(scope.row, 2)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >审核详情</el-button
              >
              <el-button
                @click="quesDetail(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >问题详情</el-button
              >
            </template>
            <template v-slot:errDescribe="{ scope }">
              <div :class="scope.row.errDescribe && scope.row.errDescribe.length > 40 ? 'more' : 'box box-center'">
                <span>1s{{ scope.row.errDescribe }}</span>
              </div>
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detail
      v-if="qusetionDetailDialog"
      @closeDetail="qusetionDetailDialog = false"
      :pointInfo="pointInfo"
      title1="上报问题统计分析"
      title2="问题详情"
      :showErrorQues="true"
    ></detail>

    <el-dialog
      title="错题本审核"
      width="60%"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="currentItem && currentItem.errAuditState && currentItem.errAuditState != '待审核' ? true : false"
      :close-on-press-escape="false"
    >
      <div class="ctbz">
        <div class="titles">
          <img src="@/assets/image/ctTips.png" />
          <span class="bz">错题处置备注</span>
        </div>
        <div class="desc">
          {{ currentItem && currentItem.errDescribe }}
        </div>
      </div>
      <div class="applyRm">审核意见</div>

      <!-- 审核后显示 -->
      <div v-if="currentItem && currentItem.errAuditState && currentItem.errAuditState != '待审核'">
        <div class="avatar">
          <img src="@/assets/image/sh-tz.png" />
          <span>审核人：{{ currentItem.errAuditUsermame }}</span>
        </div>
        <div class="apply">
          <span>审核时间</span><span>{{ currentItem.errAuditTime }}</span>
        </div>
        <div class="apply"><span>审核结果</span><span>审核{{ currentItem.errAuditState }}</span></div>
        <div class="apply">
          <span>审核意见</span><span>{{ currentItem.errAuditDescribe }}</span>
        </div>
      </div>

      <!-- 未审核显示 -->
      <div v-else>
        <el-form :model="ruleForm" :rules="rules">
          <el-form-item
            label="错题审核"
            prop="errAuditState"
            :label-width="formLabelWidth"
          >
            <el-radio-group v-model="ruleForm.errAuditState">
              <el-radio label="通过">通过</el-radio>
              <el-radio label="不通过">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="审核意见"
            prop="errAuditDescribe"
            :label-width="formLabelWidth"
          >
            <el-input
              type="textarea"
              maxlength="500"
              show-word-limit
              placeholder="请输入"
              v-model="ruleForm.errAuditDescribe"
              style="white-space: pre-wrap;"
              :autosize="{ minRows: 6}"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
            type="primary"
            :loading="submitLoading"
            @click="submitRuleForm('ruleForm')"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { extendErrPage, extendErrAudit } from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import detail from "../reportproblemAnalysis/components/detail.vue";
export default {
  components: {
    commonTable,
    detail
  },
  data() {
    return {
      formLabelWidth: "80px",
      dialogFormVisible: false,
      submitLoading: false,
      ruleForm: {
        errAuditState: "",
        errAuditDescribe: ""
      },
      rules: {
        errAuditState: [{ required: true, message: "请选择审核状态", trigger: "blur" }],
        errAuditDescribe: [
          { required: true, message: "请输入审核意见", trigger: "blur" }
        ]
      },
      date: [],
      currentItem: {},
      form: {
        caseNumber: "",
        errAuditState: "",
        errCreateTimeEnd: "",
        errCreateTimeStart: "",
        eventIndexName: "",
        eventName: "",
        pointName: "",
        reportSource: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "caseNumber",
            label: "案件号",
            width: '150px'
          },
          {
            slot: "reportSource",
            label: "数据来源"
          },
          {
            prop: "eventName",
            label: "事项名称"
          },
          {
            prop: "eventIndexName",
            label: "事项指标"
          },
          {
            slot: "errDescribe",
            label: "问题描述",
            showToolitip: '1',
            width: '300px'
          },
          {
            prop: "communityName",
            label: "社区"
          },
          {
            prop: "pointName",
            label: "点位"
          },
          {
            prop: "errCreateTime",
            label: "错题上报时间"
          },
          {
            prop: "errAuditState",
            label: "审核状态"
          },
          {
            slot: "operation",
            label: "操作",
            width: "250"
          }
        ]
      },
      taskTypeList: [
        {
          label: "网格上报",
          value: "wg"
        },
        {
          label: "居民上报未转网格",
          value: "jm"
        },
        {
          label: "居民转网格",
          value: "jmToWg"
        },
        {
          label: "企业上报",
          value: "qy"
        }
      ],
      taskTypeObj: {
        "jm": '居民上报未转网格',
        "wg": '网格上报',
        "qy": '企业上报',
        "jmToWg": '居民转网格',
      },
      exportLoading: false,
      applyStateList: [
        {
          label: "待审核",
          value: "待审核"
        },
        {
          label: "通过",
          value: "通过"
        },
        {
          label: "不通过",
          value: "不通过"
        }
      ],
      pointInfo: {},
      qusetionDetailDialog: false
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
  },
  methods: {
    // 审核 type 1 审核，2 审核详情，可根据调接口后或者列表值判断弹窗是去审核还是显示详情
    apply(item, type) {
      // todolist
      this.currentItem = item;
      this.currentItem.showType = type;
      this.dialogFormVisible = true;
    },

    // 审核提交
    async submitRuleForm() {
      if (!this.ruleForm.errAuditState) return this.$message.error("请选择审核状态");
      if (!this.ruleForm.errAuditDescribe) return this.$message.error("请输入审核意见");
      this.submitLoading = true;
      let res = await extendErrAudit({
        ...this.ruleForm,
        id: this.currentItem.id
      });
      if (res.data.code == 200) {
        this.dialogFormVisible = false;
        this.ruleForm.errAuditState = "";
        this.ruleForm.errAuditDescribe = "";
        this.getPointTypeListPageFun();
      }
      this.submitLoading = false;
    },

    // 问题详情, 尝试直接显示详情弹窗然后显示出问题详情错题
    // 同问题统计分析问题详情审核通过后，问题详情页面中需增加错题处置备注
    quesDetail(item) {
      this.pointInfo = item;
      this.qusetionDetailDialog = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form = this.$options.data().form;
      this.date = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 分页查询
    async getPointTypeListPageFun() {
      this.exportLoading = true;
      let params = {
        ...this.form,
        errCreateTimeStart: this.date && this.date.length ? this.date[0]: '',
        errCreateTimeEnd: this.date && this.date.length ? this.date[1]: '',
        page: this.page.page,
        size: this.page.size
      };
      const res = await extendErrPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
      this.exportLoading = false;
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

/deep/ .el-textarea__inner {
  padding: 15px !important;
}
/deep/ .el-textarea .el-input__count {
  color: #909399;
  background: transparent;
  position: absolute;
  font-size: 12px;
  bottom: -10px;
  right: 10px;
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
.ctbz {
  margin: 10px 0;
  .titles {
    background: url("~@/assets/image/ctBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    padding: 5px 16px;
    .bz {
      margin-left: 5px;
      font-family: MiSans;
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #494c4f;
    }
  }
  .desc {
    background: #f7fbff;
    padding: 12px 16px;
    font-family: MiSans;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
    color: #494c4f;
  }
}
.apply {
  margin-top: 10px;
  display: flex;
  span {
    &:first-child {
      font-family: MiSans;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      color: #92979c;
      margin-right: 20px;
    }
    &:last-child {
      font-family: MiSans;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      color: #494c4f;
      flex: 1;
    }
  }
}
.applyRm {
  margin: 20px 0;
  color: #494c4f;
  font-size: 18px;
  font-weight: 500;
}
.avatar {
  display: flex;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
  }
  span {
    color: #494c4f;
    font-weight: 500;
    margin-left: 10px;
    font-size: 16px;
  }
}
/deep/ .el-tooltip__popper {
  margin-left: 20px; /* 调整左侧边距，避免被黑边遮挡 */
  box-shadow: none; /* 若黑边是阴影，可移除 */
  border: none; /* 若黑边是边框，可移除 */
}

.more {
  padding:10px 5px; 
  height: 70px; 
  overflow: auto;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/errorApply/index.vue